
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qmee/deals",
      function () {
        return require("private-next-pages/qmee/deals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qmee/deals"])
      });
    }
  